import {useDispatch} from 'react-redux'
import {resetFilterEvent} from '../../../../../core/google-tag-manager/reports/reset-filter-event'
import {resetFilter} from '../../../../../store/state/report-filters/action-creators'
import * as Styles from './reset-filter-button.styled'

export function ResetFilterButton(): JSX.Element {
    const dispatch = useDispatch()

    return (
        <Styles.Button
            id="reset-button-reports"
            onClick={(e) => {
                e.preventDefault()
                resetFilterEvent()
                dispatch(resetFilter())
            }}
        >
            Reset
        </Styles.Button>
    )
}
